export const getUrlWithoutMailto = (url: string) => {
    let cleanedUrl = url.toLowerCase();
    cleanedUrl = cleanedUrl.replace('mailto:', '');
    return cleanedUrl;
}